import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { fetchPress } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import './BlogPage.css';

import News from '../components/News';

class PressPage extends Component {
  constructor() {
    super();

    this.state = {
      limit: 5
    }
  }

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.press.fields) {
      this.props.fetchPress(locale, this.state.limit);
    }
  }

  loadMore(locale, limit = 5) {
    const newLimit = this.state.limit+limit;
    this.setState({
      limit: newLimit
    })
    this.props.fetchPress(locale, newLimit);
  }

  render() {
    const locale = this.props.intl.locale;
    const {press} = {...this.props};

    const slug = this.props.match.params.slug;

    let release;

    if(slug) {
      release = press.find((p) => {
        return p.fields.slug === this.props.match.params.slug;
      })
    }

    return (
      <div className="news press">
        <Helmet>
          <title>{this.props.intl.messages["header.press"]}</title>
        </Helmet>
        {!press && <Loader/>}
        {(release && release.fields.title && release.fields.lead) && <News release={release} visible url={window.location.href} />}
        {(!release && press) && press.map((release) => {
          if(release.fields.title && release.fields.lead) { 
            return(
              <News key={release.sys.id} url={window.location.href+'/'+release.fields.slug} release={release} />
            )
          }
          return null;
        })}
        {((!release && press) && (this.state.limit <= press.length)) && 
          <div className="load-more" onClick={() => this.loadMore(locale)}>
            <span className="btn">{this.props.intl.messages["general.loadMore"]}</span>
          </div>
        }
      </div>
    );
  }
}

PressPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  press: state.press
});

const mapDispatchToProps = {
  fetchPress
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(PressPage));


// WEBPACK FOOTER //
// ./src/containers/PressPage.js